<template>
  <appTooltipBase
    v-if="getIsTooltipsActive && tooltipContent"
    :tooltip="tooltip"
    :tooltipContent="tooltipContent"
  ></appTooltipBase>
</template>
<script>
import { useTooltipsStore } from "@/stores/modules/tooltips";
import { mapState } from "pinia";

export default {
  props: {
    tooltip: {
      type: String,
      default() {
        return null;
      }
    }
  },
  computed: {
    ...mapState(useTooltipsStore, ["getIsTooltipsActive", "getTooltipContent"]),
    tooltipContent: function () {
      if (this.tooltip) {
        return this.getTooltipContent(this.tooltip);
      }
      return false;
    }
  }
};
</script>
